import React from 'react';
import Login from "../components/Login";
import ReportsPage from "../pages/ReportsPage";
import SetupPage from "../pages/SetupPage";

export const routesTabs = [
    { id:0, title: "Авторизация", path: "/login", component: Login, componentJSX: <Login />, exact: true, needAuth: false, canWhenAuth: false, needAdmin: false },
//    { path: "/reports/:pagename", component: ReportsPage, exact: true, needAuth: true, canWhenAuth: true },
    { id: 1, title: "Список отчетов", path: "/reports", component: ReportsPage, componentJSX: <ReportsPage />,  exact: true, needAuth: true, canWhenAuth: true, needAdmin: false },
    { id: 2, title: "Настройки", path: "/setup", component: SetupPage, componentJSX: <SetupPage />, exact: true, needAuth: true, canWhenAuth: true, needAdmin: true },


]
